module.exports = __webpack_public_path__ + "img/arrow-right.25cf1930.svg";